"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BaseActions;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actions = _interopRequireDefault(require("@site/pattern-library-core/actions"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _index = _interopRequireDefault(require("../../buttons/add-to-cart/index.js"));
var _index2 = _interopRequireDefault(require("../../buttons/video-play-button/index.js"));
var _index3 = _interopRequireDefault(require("../../buttons/get-the-app/index.js"));
var _index4 = _interopRequireDefault(require("../../../experiments/header-cart-button/index.js"));
var _index5 = _interopRequireDefault(require("../../../page-body/other/modal-lightbox/index.js"));
var _index6 = _interopRequireDefault(require("../../../experiments/conversational-search-modal/index.js"));
var _index7 = _interopRequireDefault(require("../../../experiments/lead-gen-modal-button/index.js"));
var _index8 = _interopRequireDefault(require("../../../experiments/commerce-lead-gen-new-modal-button/index.js"));
var _index9 = _interopRequireDefault(require("../../buttons/link/index.js"));
/**
 * Render Actions.
 *
 * @param {string} actionsLayout The actions layout to render
 * @param {array} ctas ctas array, supported types: NSMerchButton, AddToCartButton, VideoPlayButton, InputBar, and EPSearch.
 * @param {string} disclaimer Disclaimer text
 * @param {object} actionsTemplateMap Extra templates, to avoid circular dependencies
 * @returns {React.ReactElement} Actions
 * @public
 */
function BaseActions({
  actionsLayout = 'none',
  actionsTemplateMap,
  ctas,
  disclaimer
}) {
  const buttonSetSupportedTemplateMap = {
    'GetTheAppButton': _index3.default,
    'addToCart': _index.default,
    'VideoPlayButton': _index2.default,
    'Button Component': _merchButton.NSMerchButton,
    'HeaderCartButton': _index4.default,
    'ConversationalSearchModal': _index6.default,
    'LeadGenModalButton': _index7.default,
    'CommerceLeadGenNewModalButton': _index8.default,
    'Link': _index9.default,
    'ModalLightbox': _index5.default
  };
  const templateComponentMap = {
    ...buttonSetSupportedTemplateMap,
    ...actionsTemplateMap
  };
  return /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: actionsLayout,
    ctas: ctas,
    disclaimer: disclaimer,
    actionsTemplateMap: templateComponentMap
  });
}
BaseActions.propTypes = {
  /**
   * Actions layout
   */
  actionsLayout: _propTypes.default.oneOf(['button-set', 'input-bar', 'domain-search', 'es-search', 'none']),
  ctas: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node])).isRequired,
  disclaimer: _propTypes.default.string,
  actionsTemplateMap: _propTypes.default.object
};